import { render, staticRenderFns } from "./AuthoriseModal.vue?vue&type=template&id=780c3339&scoped=true"
import script from "./AuthoriseModal.vue?vue&type=script&lang=js"
export * from "./AuthoriseModal.vue?vue&type=script&lang=js"
import style0 from "./AuthoriseModal.vue?vue&type=style&index=0&id=780c3339&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780c3339",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('780c3339')) {
      api.createRecord('780c3339', component.options)
    } else {
      api.reload('780c3339', component.options)
    }
    module.hot.accept("./AuthoriseModal.vue?vue&type=template&id=780c3339&scoped=true", function () {
      api.rerender('780c3339', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AuthoriseModal.vue"
export default component.exports